var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      {
        staticStyle: { "line-height": "100%", "margin-bottom": "0cm" },
        attrs: { align: "center" }
      },
      [
        _c(
          "font",
          { attrs: { face: "Calibri, serif" } },
          [
            _c(
              "font",
              { staticStyle: { "font-size": "14pt" }, attrs: { size: "4" } },
              [_c("b", [_vm._v("FORMULÁRIO DE ANÁLISE DE FORNECEDORES ")])]
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "p",
      {
        staticStyle: { "line-height": "100%", "margin-bottom": "0cm" },
        attrs: { align: "center" }
      },
      [
        _c(
          "font",
          { attrs: { face: "Calibri, serif" } },
          [
            _c(
              "font",
              { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
              [
                _c("u", [
                  _vm._v(
                    "Análise de adequação às exigências da Lei Geral de Proteção de Dados Pessoais (LGPD)"
                  )
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }